import { createThirdwebClient } from "thirdweb";

const clientID = process.env.NEXT_PUBLIC_CLIENT_ID;

if (clientID) {
    throw new Error('Client ID not found');
}
export const client = createThirdwebClient({
  clientId: "34d73d1184693e56e37496f045510c1d",
});